import React from 'react';
import { colors } from './constants';
import { InfoIcon, XIcon } from './Icons';

const ConfirmDialog = ({ show, onClose, confirmAction, confirmActionExecute }) => {
  if (!show || !confirmAction) return null;

  const styles = {
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    },
    modal: {
      background: colors.cream100,
      borderRadius: '12px',
      width: '90%',
      maxWidth: '450px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
    },
    modalHeader: {
      padding: '24px',
      borderBottom: `1px solid rgba(94, 82, 64, 0.12)`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    modalTitle: {
      fontSize: '18px',
      fontWeight: 550,
      color: colors.slate900,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      color: colors.slate500,
      borderRadius: '6px',
      transition: 'all 0.2s ease'
    },
    modalBody: {
      padding: '24px',
      fontSize: '14px',
      color: colors.slate900,
      lineHeight: '1.6'
    },
    modalFooter: {
      padding: '24px',
      borderTop: `1px solid rgba(94, 82, 64, 0.12)`,
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end'
    },
    btnPrimary: {
      padding: '12px 24px',
      fontSize: '14px',
      fontFamily: 'inherit',
      fontWeight: 500,
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      background: colors.teal500,
      color: colors.cream50
    },
    btnSecondary: {
      padding: '12px 24px',
      fontSize: '14px',
      fontFamily: 'inherit',
      fontWeight: 500,
      borderRadius: '8px',
      border: `1px solid rgba(94, 82, 64, 0.2)`,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      background: 'transparent',
      color: colors.slate900
    }
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>
            <InfoIcon />
            Confirm Action
          </h2>
          <button 
            style={styles.closeButton}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(94, 82, 64, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
            }}
          >
            <XIcon />
          </button>
        </div>

        <div style={styles.modalBody}>
          {confirmAction.message}
        </div>

        <div style={styles.modalFooter}>
          <button 
            style={styles.btnSecondary}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(94, 82, 64, 0.08)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
            }}
          >
            Cancel
          </button>
          <button 
            style={styles.btnPrimary}
            onClick={confirmActionExecute}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = colors.teal600;
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(33, 128, 141, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = colors.teal500;
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
